import Api from '../api'

const END_POINT = 'admin/fields';

export default {
    state: {
        fields: [],
        selectedFields: []
    },

    getters: {
        getField: (state, field) => {
            const index = state.fields.indexOf(field);
            return state.fields[index];
        },
        getFields: state => state.fields,
        getSelectedFields: state => state.selectedFields
    },

    mutations: {
        setFields(state, fields) {
            state.fields = fields
        },
        setField(state, field){
            state.fields.unshift(field);
        }, 
        updateField(state, field){
            let index = state.fields.indexOf(field);
            state.fields.splice(index, 1, field);

            if(field.selected){
                state.selectedFields.push(field);
            } else {
                index = state.selectedFields.indexOf(field);
                state.selectedFields.splice(index, 1);
            }
        },
        clearSelected: state => {
            state.selectedFields = [];
            state.fields.forEach((field, index, fields) => {
                field.selected = false;
                fields.splice(index, 1, field);
            });
        }
    },

    actions: {
        async fetchFields({commit}){
            const response = await Api.get(END_POINT);
            commit('setFields', response.body.data);
        },
        async storeField({commit}, data){
            const response = await Api.post(END_POINT, data);
            commit('setField', response.body.data);
        },
        selectField({commit}, field){
            field.selected = !field.selected;
            commit('updateField', field);
        },
        clearSelected({commit}){
            commit('clearSelected');
        }
    }
}